import { axiosPatientInstance } from "config";
import { ProviderChartCode, SummaryReasons, TriageChartCode } from "enums";
import { useAxiosMutation } from "hooks";

type UseGenerateCustomSummaryDocumentPayload = {
  charts?: (ProviderChartCode | TriageChartCode)[];
  addPatientDemographics?: boolean;
  addRegistrationDocuments?: boolean;
  addInsuranceInformation?: boolean;
  addNursingChartSummary?: boolean;
  addProviderChartSummary?: boolean;
  addLabReports?: boolean;
  addRadiologyReports?: boolean;
  addEkgReports?: boolean;
  addDischargeFile?: boolean;
  addObservationFile?: boolean;
  addMedicationsReport?: boolean;
  addAllergiesMedsReport?: boolean;
  miscFilesToAdd?: string[];
};

function useGenerateCustomSummaryDocument(
  encounterId: string,
  reason?: SummaryReasons,
  otherReason?: string
) {
  return useAxiosMutation(
    ["generateCustomSummaryDocument", { encounterId }],
    (payload: UseGenerateCustomSummaryDocumentPayload) =>
      axiosPatientInstance.post<Blob>(
        `v1/summary/${encounterId}/custom`,
        payload,
        {
          responseType: "blob",
          params: {
            reason,
            description: otherReason,
            summaryType: "Medical Record",
          },
        }
      )
  );
}

export type { UseGenerateCustomSummaryDocumentPayload };
export { useGenerateCustomSummaryDocument };
